import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Iscrizione from "@/pages/Iscrizione";
import Guide from "@/pages/Guide";
import Articolo from "@/pages/Articolo";
import Assistenza from "@/pages/Assistenza";
import Prenota from "@/pages/Prenota";
import Faq from "@/pages/Faq";
import Privacy from "@/pages/Privacy";
import OttoPerMillePage from "@/pages/OttoPerMillePage";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <a
        href="#contenuto"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:bg-brand-blue focus:text-white focus:px-4 focus:py-2 focus:rounded-lg"
      >
        Salta al contenuto
      </a>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <main id="contenuto" className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/iscrizione" element={<Iscrizione />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/guide/:slug" element={<Articolo />} />
            <Route path="/assistenza" element={<Assistenza />} />
            <Route path="/prenota" element={<Prenota />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/otto-per-mille" element={<OttoPerMillePage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <ChatWidget />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
